/**
 * The card. Two grounds only: `raised` for things that carry a value or an
 * action, `surface` for panels that hold a list or a log.
 *
 * Only `surface` is outlined. On the navy-900 page a raised card is three
 * steps lighter than its ground and reads as a card on tint alone; drawing a
 * border around it too was the second of two ways to say the same thing, and
 * a screen of a dozen of them read as panes of glass stacked on each other.
 * `surface` is one step from the page and would dissolve without its line.
 */
const SurfaceCard = ({
  children,
  tone = 'raised',
  radius = 'card',
  className = '',
}: {
  children: React.ReactNode,
  tone?: 'raised' | 'surface',
  radius?: 'card' | 'container',
  className?: string,
}) => (
  <div
    className={[
      tone === 'raised' ? 'bg-navy-700' : 'bg-navy-800 border border-navy-500',
      radius === 'card' ? 'rounded-card' : 'rounded-container',
      className,
    ].join(' ')}
  >
    {children}
  </div>
)

export default SurfaceCard
